module.exports = __webpack_public_path__ + "img/heart-white.1c17226e.svg";